module.exports = __webpack_public_path__ + "static/media/status-I.613c1aba.png";